export default __webpack_public_path__ + "static/media/aliamat_body.f984caa9.png";